export default "__VITE_PUBLIC_ASSET__2bfbc1ba__"